import React, { useState } from 'react';
import { Column, Container, Main, Row } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  faFacebookSquare,
  faInstagramSquare,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons';

export const NewFooter = () => {
  const [socialMedias] = useState({
    facebook: 'https://facebook.com/recruteibr',
    linkedin: 'https://linkedin.com/company/recruteibr',
    instagram: 'https://instagram.com/recruteibr',
    twitter: 'https://twitter.com/recruteioficial',
    tiktok: 'https://vm.tiktok.com/TTPdSBChnf/',
    youtube: 'https://www.youtube.com/c/Recrutei-plataforma-recrutamento',
    pinterest: 'https://br.pinterest.com/recrutei/_saved/',
  });

  return (
    <Main>
      <Container>
        <h2>Desenvolvido por</h2>
        <img src="/static/logo_recrutei_colorida.png" />
      </Container>
      <Column>
        <h2>
          Todos os Direitos Reservados - Recrutei © {new Date().getFullYear()}
        </h2>
        <Row>
          <div className="social-media">
            <a href={socialMedias?.instagram}>
              <FontAwesomeIcon icon={faInstagramSquare} color="#081847" />
            </a>
            <a href={socialMedias?.linkedin}>
              <FontAwesomeIcon icon={faLinkedin} color="#081847" />
            </a>
            <a href={socialMedias?.facebook}>
              <FontAwesomeIcon icon={faFacebookSquare} color="#081847" />
            </a>
          </div>
        </Row>
      </Column>
    </Main>
  );
};

NewFooter.propType = {};
